import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import useLocalization from "../../hooks/useLocalization";

const Dialog_Flex = ({
  open,
  onClose,
  title,
  message,
  actions,
  onAction,
  children,
}) => {
  const { getLabel } = useLocalization();

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: "pre-wrap" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      {children ? children : null}
      <DialogActions>
        {actions?.map((action) => (
          <Button
            key={action.name}
            onClick={() => onAction(action.name)}
            variant="contained"
            size="small"
          >
            {getLabel(action.label)}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default Dialog_Flex;
